vvReadMoreLink = document.getElementById('vv-read-more-link');
if(vvReadMoreLink){
  vvReadMoreLink.addEventListener("click", function(event) {
  	event.preventDefault();
    vvReadMoreLink.style.display = 'none';
    vvReadMoreContent = document.getElementById('vv-read-more-content');
    if(vvReadMoreContent){
      vvReadMoreContent.style.display = 'block';
    }
    vvReadLessLink = document.getElementById('vv-read-less-link');
    if(vvReadLessLink){
      vvReadLessLink.style.display = 'block';
    }
  }); 
}
vvReadLessLink = document.getElementById('vv-read-less-link');
if(vvReadLessLink){
  vvReadLessLink.addEventListener("click", function(event) {
    event.preventDefault();
    vvReadLessLink.style.display = 'none';
    vvReadMoreContent = document.getElementById('vv-read-more-content');
    if(vvReadMoreContent){
      vvReadMoreContent.style.display = 'none';
    }
    vvReadMoreLink = document.getElementById('vv-read-more-link');
    if(vvReadMoreLink){
      vvReadMoreLink.style.display = 'block';
    }
  });
}
